// extracted by mini-css-extract-plugin
export var container = "_43-0";
export var icon = "_43-1";